import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from '@material-ui/core/Checkbox'
import Typography from '@material-ui/core/Typography'
import PGAIcon from 'images/pga-seal-icon.svg'
import { useStyles } from './styles'

// Mirrors the marketing opt-in restyled for the group event registration
// redesign (PR #4160, `things-to-do/events/register/.../redesign/`). Once that
// merges, both can share one component. `checked` is null until the golfer
// touches the box, then true/false, exactly like the shared `MarketingOptIn`.
const MarketingOptInCard = ({ checked, onChange }) => {
  const classes = useStyles()

  return (
    // A label, so tapping the copy ticks the box (as the shared `MarketingOptIn`).
    <label className={classes.optIn} data-testid="marketing-opt-in">
      <Checkbox
        checked={checked === true}
        onChange={e => onChange(e.target.checked)}
        className={classes.optInCheckbox}
        inputProps={{
          'aria-labelledby': 'marketing-opt-in-title',
          'aria-describedby': 'marketing-opt-in-consent',
        }}
      />
      <div>
        <div className={classes.optInHeader}>
          <img
            className={classes.optInLogo}
            src={PGAIcon}
            alt="PGA logo"
            width={32}
            height={32}
          />
          <Typography
            id="marketing-opt-in-title"
            variant="h6"
            component="p"
            className={classes.optInTitle}
          >
            We love this game. How about you?
          </Typography>
        </div>
        <p className={classes.optInBody}>
          Join the PGA of America email community for local golf programs,
          ticketing and volunteer opportunities, swing tips and exclusive
          offers. Unsubscribe anytime.
        </p>
        <p id="marketing-opt-in-consent" className={classes.optInConsent}>
          By checking this box, I confirm my request to be contacted by email by
          The Professional Golfers&apos; Association of America
          (&quot;PGA&quot;), PGA Tournament Corporation, Inc. (&quot;PTC&quot;)
          and/or PGA of America partners. I acknowledge that I can withdraw my
          consent at any time by following the &apos;unsubscribe&apos;
          instructions provided on any communication I receive from this
          service.
        </p>
      </div>
    </label>
  )
}

MarketingOptInCard.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}

export default MarketingOptInCard
